import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GridDto, ServerPagingResult } from '@hub/generated/models';
import { IOnLazyLoad } from '@hub/interfaces/IOnLazyLoad';
import { GridStylingDto } from '@hub/models/grids/GridStylingDto';
import { SortMeta } from 'primeng/api';

@Component({
  selector: 'app-grid-content',
  templateUrl: './gridContent.component.html'
})
export class GridContentComponent {
  private _pagingResults: ServerPagingResult<any>;

  @Input() ActiveFlag: string;
  @Input() set PagingResult(p: ServerPagingResult<any>) {
    this._pagingResults = p;
    this.First = (p.Page - 1) * p.PageSize;
  }
  get PagingResult() {
    return this._pagingResults;
  }
  @Input() RowsPerPage: Number[];
  @Input() Sorting: SortMeta[];
  @Input() FooterText: String;
  @Input() IsGridEdit: boolean = false;
  @Input() GridData: GridDto;
  @Input() ShowRedirectHeader: boolean;
  @Input() Styling: GridStylingDto<any>;
  @Input() IsEmptyMessage: boolean = true;
  @Input() IsQuickSearchEnabled: boolean = false;

  // Outputs
  @Output() quickSearchEvent = new EventEmitter<string>();
  @Output() onReorder: EventEmitter<IOnLazyLoad> = new EventEmitter<IOnLazyLoad>();
  @Output() onLazyLoad: EventEmitter<IOnLazyLoad> = new EventEmitter<IOnLazyLoad>();
  @Output() onShowOptions: EventEmitter<IOnLazyLoad> = new EventEmitter<IOnLazyLoad>();

  @Output() selectionChange = new EventEmitter();
  @Input() selection: any[] = [];

  @Output() GridDataChange = new EventEmitter<GridDto>();

  // View Properties
  First: number;

  // View Children

  public lazyLoad(val: IOnLazyLoad) {
    this.onLazyLoad.emit(val);
  }

  public reorder(values) {
    this.GridData.Columns = values;
    this.GridDataChange.emit(this.GridData);
  }

  public rowSelect(event) {
    this.selectionChange.emit(this.selection);
  }

  public rowUnselect(event) {
    this.selectionChange.emit(this.selection);
  }

  public toggleOptions(val: IOnLazyLoad) {
    this.onShowOptions.emit(val);
  }

  onGridDataChange(event) {
    this.GridData = event;
    this.GridDataChange.emit(event);
  }

  onQuickSearch(event) {
    this.quickSearchEvent.emit(event);
  }

  onSelectionChange(event) {
    this.selectionChange.emit(this.selection);
  }
}
